import React from 'react';
import { connect } from 'react-redux';
import { setFixedCosts, setActiveTab } from '../actions/actions';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Button from '@material-ui/core/Button';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import styled from 'styled-components';
import { Typography, Container, OutlinedInput } from '@material-ui/core';
import NumberFormat from 'react-number-format';

const ContentArea = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (min-width: 801px) {
    border-right: 1px solid #8080803d;
  };`;

const TabTitle = styled(Typography)`
  place-self: center;
  margin-right: 12px !important;
  margin-top: 16px !important;
`;

const ResponsiveContainer = styled(Container)`
  margin: 24px;
}
`

const BackButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: start;
align-self: center;
margin-left: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '<';
    font-size: 16px;
  }
}
`
const NavArea = styled.div`
display: grid;
grid-template-columns: auto auto;
`;


const NextButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: end;
align-self: center;
margin-right: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '>';
    font-size: 16px;
  }
}
`

const FixedCostsContainer = styled(Container)`
    margin: 12px;
    display: grid;
    grid-template-columns: 40% 40%;
    grid-template-rows: auto auto auto auto;
}
`

const MCInput = styled(OutlinedInput)`
  margin-top: 16px;
`


function TabContent(props) {
  const handleFocus = (event) => event.target.select();

  const handleAdminChange = (values) => {
    props.setFixedCosts({ ...props.financialSetup.fixedCosts, admin: values.value })
  }

  const handleHRChange = (values) => {
    props.setFixedCosts({ ...props.financialSetup.fixedCosts, HR: values.value })
  }

  const handleOccupationalChange = (values) => {
    props.setFixedCosts({ ...props.financialSetup.fixedCosts, occupational: values.value })
  }

  const handleMaintenanceChange = (values) => {
    props.setFixedCosts({ ...props.financialSetup.fixedCosts, maintenance: values.value })
  }

  const handleOthersChange = (values) => {
    props.setFixedCosts({ ...props.financialSetup.fixedCosts, others: values.value })
  }

  return (
    <ContentArea>
      <TabTitle variant="h4">Custos fixos</TabTitle>
      <FixedCostsContainer>
        <TabTitle variant="subtitle1">Recursos Humanos</TabTitle>
        <NumberFormat value={props.financialSetup.fixedCosts.HR} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleHRChange} prefix={'R$'} />
        <TabTitle variant="subtitle1">Administrativos</TabTitle>
        <NumberFormat value={props.financialSetup.fixedCosts.admin} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleAdminChange} prefix={'R$'} />      
        <TabTitle variant="subtitle1">Ocupação</TabTitle>
        <NumberFormat value={props.financialSetup.fixedCosts.occupational} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleOccupationalChange} prefix={'R$'} />
        <TabTitle variant="subtitle1">Manutenção</TabTitle>
        <NumberFormat value={props.financialSetup.fixedCosts.maintenance} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleMaintenanceChange} prefix={'R$'} />
        <TabTitle variant="subtitle1">Outros</TabTitle>
        <NumberFormat value={props.financialSetup.fixedCosts.others} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleOthersChange} prefix={'R$'} />
      </FixedCostsContainer>
      <ResponsiveContainer>
        <Typography variant="h6">Ajuda</Typography>
        <Typography variant="body">Aqui devem ser informados aqueles <b>custos que independentemente do faturamento devem ser pagos</b>, como por exemplo a folha de pagamento. Para efeito de cálculos, considere a energia elétrica, gás e água como custos fixos.
          </Typography>
      </ResponsiveContainer>
      <NavArea>
        <BackButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab - 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          endIcon={<NavigateBeforeIcon />}
        >
          Voltar
        </BackButton>
        <NextButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab + 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          endIcon={<NavigateNextIcon />}
        >
          Próximo
          </NextButton>
      </NavArea>
    </ContentArea>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup,
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setFixedCosts, setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabContent)
